import axios from 'axios'
import { getCookie } from '../axios/CookieConfig'

const baseURL = 'https://api.fee.inflection.org.in/'

// const baseURL = 'http://192.168.1.151:5000/'

let apiClient = axios.create({
  baseURL: baseURL,
  headers: {
    'Content-Type': 'application/json',

    'ngrok-skip-browser-warning': true,
  },
  timeout: 20000,
})

const setToken = (tokenName) => {
  apiClient = axios.create({
    baseURL,
    withCredentials: false,
    timeout: 30000,
    headers: {
      authorization: `Bearer${getCookie(tokenName)}`,
      Accept: 'application/json',
    },
  })
}

const setAuthHeader = (tokenName) => {
  apiClient = axios.create({
    baseURL,
    withCredentials: false,
    timeout: 30000,
    headers: {
      authorization: `Bearer ${getCookie(tokenName)}`,
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  })
}

// ------------------ api call Routes -----------------------

const login = (payload) => {
  return apiClient.post('/login', payload)
}
const allStudent = () => {
  return apiClient.get('/admissions')
}
const registration = (payload) => {
  return apiClient.post('/admissions', payload)
}
const UpdateRegistrationFrom = (id, payload) => {
  return apiClient.patch(`/admissions/${id}`, payload)
}
const fetchStudentDetails = (id) => {
  return apiClient.get(`/admissions/${id}`)
}
// **************fees *****************
const paidFees = (payload) => {
  return apiClient.post('/fees', payload)
}
const getAllFee = (date) => {
  return apiClient.get(`/fees?from=${date}`)
}
const getAllFeeList = (to, from) => {
  return apiClient.get(`/fees/list_fee?to=${to}&from=${from}`)
}
const fetchFees = (id) => {
  return apiClient.get(`/fees/${id}`)
}

const fetchFeesDaysWise = (month, year) => {
  return apiClient.get(`/fees/day_wise?month=${month}&year=${year}`)
}
const updateFees = (id, payload) => {
  return apiClient.patch(`/fees/${id}`, payload)
}
// **************id card *****************
const enrolCard = (id) => {
  return apiClient.patch(`admissions/card/${id}`)
}
const removedCard = (id) => {
  return apiClient.delete(`admissions/card/${id}`)
}
// **************attendance *****************
const createAttendance = (payload) => {
  return apiClient.post('attendances/', payload)
}
const getAAttendance = (id) => {
  return apiClient.get(`attendances/${id}`)
}
const getAttendance = (date) => {
  return apiClient.get(`/attendances?from=${date}`)
}
const deleteAttendance = (id) => {
  return apiClient.delete(`attendances/${id}`)
}

// **************certificate *****************

const generateCertificate = (payload) => {
  return apiClient.post('verification/', payload)
}
const fetchAllCtrById = (id) => {
  return apiClient.get(`verification/cid/${id}`)
}
const fetchAllCtr = () => {
  return apiClient.get('/verification')
}
const deleteCtr = (id) => {
  return apiClient.delete(`verification/${id}`)
}
// **************expanse *****************
const createExpanse = (payload) => {
  return apiClient.post('/expense', payload)
}
const fetchExpanse = (from, to) => {
  return apiClient.get(`/expense?from=${from}&to=${to}`)
}
const deleteExpanse = (id) => {
  return apiClient.delete(`expense/${id}`)
}
const fetchExpanseById = (id) => {
  return apiClient.get(`/expense/get_expense_per_user/${id}`)
}
const updateExpanse = (id, payload) => {
  return apiClient.patch(`/expense/u_expense/${id}`, payload)
}

// ***************batch*************************
const createBatch = (payload) => {
  return apiClient.post('/batch', payload)
}
const fetchBatch = () => {
  return apiClient.get('/batch')
}
const updateBatch = (id, payload) => {
  return apiClient.patch(`/batch/${id}`, payload)
}
const deleteBatch = (id) => {
  return apiClient.delete(`/batch/${id}`)
}

// *************** student batch*************************

const AddStdBatch = (payload) => {
  return apiClient.post('/student_batch', payload)
}
const fetchStdBatch = (id) => {
  return apiClient.get(`/student_batch/${id}`)
}
const deleteStdBatch = (id) => {
  return apiClient.delete(`/student_batch/${id}`)
}
// *******dashboard *****************************************

const fetchToExpense = (month, year) => {
  return apiClient.get(
    `/expense/d_total_collection?month=${month}&year=${year}`,
  )
}
const fetchDashStudent = (month, year) => {
  return apiClient.get(`/admissions/t_admission?month=${month}&year=${year}`)
}
const fetchDashBoardDetails = () => {
  return apiClient.get('/dashboard')
}
const fetchDashBoardLeavePending = () => {
  return apiClient.get('/leave/get_list_approval')
}
const fetchDashBoardExpensePending = () => {
  return apiClient.get('/expense/list/pending_expense')
}
// ***************batch lecture*************************

const createLecBatch = (payload) => {
  return apiClient.post('/lecture', payload)
}
const fetchLecBatch = (id) => {
  return apiClient.get(`/lecture/${id}`)
}
const deleteLceBatch = (id) => {
  return apiClient.delete(`/lecture/${id}`)
}

// ***************record*************************

const createRecord = (payload) => {
  return apiClient.post('/record', payload)
}
const fetchRecord = () => {
  return apiClient.get('/record')
}
const fetchDateByRecord = (date) => {
  return apiClient.get(`/followup/next/${date}`)
}
const deleteRecord = (id) => {
  return apiClient.delete(`/record/${id}`)
}

const UpdateRecord = (id, payload) => {
  return apiClient.patch(`/record/update/${id}`, payload)
}

// ***************follow up*************************

const createFollowUp = (payload) => {
  return apiClient.post('/followup', payload)
}
const fetchFollowUp = (date) => {
  return apiClient.get(`/followup/next/${date}`)
}

const fetchFollowById = (id) => {
  return apiClient.get(`/followup/${id}`)
}

const deleteFollowUp = (id) => {
  return apiClient.delete(`/followup/${id}`)
}

const updateFollowUp = (id, payload) => {
  return apiClient.patch(`/followup/f_update/${id}`, payload)
}
// *****************employee record**********************
const createEmployee = (payload) => {
  return apiClient.post('/employee', payload)
}
const fetchEmployee = () => {
  return apiClient.get('/users')
}
const fetchOneEmployee = (id) => {
  return apiClient.get(`/users/${id}`)
}
const deleteEmployee = (id) => {
  return apiClient.delete(`/employee/${id}`)
}
// *****************employee leave**********************

const createEmployeeLeave = (payload) => {
  return apiClient.post('/leave', payload)
}
const fetchAllLeave = () => {
  return apiClient.get('/leave')
}
const fetchOneLeaveById = (id) => {
  return apiClient.get(`/leave/${id}`)
}
const updateLeave = (id, payload) => {
  return apiClient.patch(`/leave/${id}`, payload)
}
const deleteLeave = (id) => {
  return apiClient.delete(`/leave/${id}`)
}

// *****************hand over take over**********************

const createHandOverTakeOver = (payload) => {
  return apiClient.post('/handover', payload)
}
const fetchHandOverTakeOver = () => {
  return apiClient.get('/handover')
}
const fetchHandOverTakeOverById = (id) => {
  return apiClient.get(`/handover/get/${id}`)
}
const deleteHandOverTakeOver = (id) => {
  return apiClient.delete(`/handover/delete/${id}`)
}
const updateHandOverTakeOver = (id, payload) => {
  return apiClient.patch(`/handover/update/${id}`, payload)
}

// *****************collection**********************
const createCollection = (payload) => {
  return apiClient.post('/collection', payload)
}
const fetchCollection = () => {
  return apiClient.get('/collection')
}
const fetchCollectionById = (id) => {
  return apiClient.get(`/collection/${id}`)
}

const deleteCollection = (id) => {
  return apiClient.delete(`/collection/${id}`)
}

// *******************laptop manage ***********************

const createLaptop = (payload) => {
  return apiClient.post('/laptop', payload)
}
const fetchLaptop = () => {
  return apiClient.get('/laptop')
}
const deleteLaptop = (id) => {
  return apiClient.delete(`/laptop/${id}`)
}
const updateLaptop = (id, payload) => {
  return apiClient.patch(`/laptop/${id}`, payload)
}
// -------------------------Liquidity Admin------------------------------
const createLiquidity = (payload) => {
  return apiClient.post('/liquidity', payload)
}
const fetchLiquidity = () => {
  return apiClient.get('/liquidity')
}
const deleteLiquidity = (id) => {
  return apiClient.delete(`/liquidity/${id}`)
}

const fetchFeeById = (id) => {
  return apiClient.get(`fees/getFeeByUserId/${id}`)
}
const fetchAdmissionByUserId = (id) => {
  return apiClient.get(`admissions/getAdmissionByUserId/${id}`)
}

// ***************summer training register course*************************
const createCourse = (payload) => {
  return apiClient.post('/courses', payload)
}
const fetchCourse = () => {
  return apiClient.get('/courses')
}
const fetchSummerDashboard = () => {
  return apiClient.get('/registration')
}
const updateSummerRegistration = (id, payload) => {
  return apiClient.patch(`/registration/${id}`, payload)
}

const deleteCourse = (id) => {
  return apiClient.delete(`/courses/${id}`)
}

export {
  setToken,
  login,
  generateCertificate,
  fetchAllCtrById,
  setAuthHeader,
  fetchAllCtr,
  deleteCtr,
  registration,
  allStudent,
  UpdateRegistrationFrom,
  fetchStudentDetails,
  paidFees,
  fetchFees,
  getAllFee,
  getAllFeeList,
  fetchFeesDaysWise,
  updateFees,
  enrolCard,
  removedCard,
  createAttendance,
  getAttendance,
  getAAttendance,
  deleteAttendance,
  createExpanse,
  fetchExpanse,
  createBatch,
  fetchBatch,
  updateBatch,
  deleteBatch,
  AddStdBatch,
  fetchStdBatch,
  deleteStdBatch,
  createLecBatch,
  fetchLecBatch,
  deleteLceBatch,
  createFollowUp,
  fetchFollowUp,
  updateFollowUp,
  deleteFollowUp,
  createRecord,
  fetchFollowById,
  fetchRecord,
  deleteRecord,
  UpdateRecord,
  fetchDateByRecord,
  deleteExpanse,
  fetchToExpense,
  updateExpanse,
  fetchExpanseById,
  fetchDashStudent,
  fetchDashBoardDetails,
  createEmployee,
  fetchEmployee,
  deleteEmployee,
  fetchOneEmployee,
  createEmployeeLeave,
  fetchAllLeave,
  fetchOneLeaveById,
  updateLeave,
  deleteLeave,
  createHandOverTakeOver,
  fetchHandOverTakeOver,
  fetchHandOverTakeOverById,
  deleteHandOverTakeOver,
  updateHandOverTakeOver,
  createCollection,
  fetchCollection,
  deleteCollection,
  fetchCollectionById,
  createLaptop,
  fetchLaptop,
  deleteLaptop,
  updateLaptop,
  createLiquidity,
  fetchLiquidity,
  deleteLiquidity,
  fetchFeeById,
  fetchAdmissionByUserId,
  fetchDashBoardLeavePending,
  fetchDashBoardExpensePending,
  createCourse,
  fetchCourse,
  deleteCourse,
  fetchSummerDashboard,
  updateSummerRegistration,
}
